import { Image } from '@/component/Image';
import { Link } from '@/i18n/routing';
import { useLocale, useTranslations } from 'next-intl';
import { MyCarousel } from '@/component/MyCarousel';
import { getListingLocaleSlug } from '@/utils';
import { mapGtmItem, pushListingCard } from '@/utils/gtm';

import styles from './SliderCard.module.css';

export const SliderListCard = ({ item, bgGray, dataTestId }) => {
  const locale = useLocale();
  const t = useTranslations();
  const { previewImages, name, occupancy } = item;

  const pushGTM = () => pushListingCard('landing', mapGtmItem(item));
  const cardUrl = {
    href: `/listings/${getListingLocaleSlug(item, locale)}`,
    target: '_blank',
    onClick: pushGTM,
  };

  return (
    <div className="flex flex-col h-full" data-testid={dataTestId}>
      <div
        className={`h-full hover:!bg-primary-50 ${styles.card} ${
          bgGray ? 'bg-white' : 'bg-slate-50'
        }`}
      >
        <div className="flex flex-col justify-between">
          {!!previewImages?.length ? (
            <MyCarousel images={previewImages.slice(0, 3)} url={cardUrl} />
          ) : (
            <Link {...cardUrl} prefetch={false}>
              <Image
                src="https://guestit-web-assets.s3-accelerate.amazonaws.com/images/icons/guestit_dummy_image.webp"
                className="object-cover"
                alt="no image"
                title={name}
                height={308}
                width={310}
                style={{ width: 'auto' }}
              />
            </Link>
          )}
          <Link {...cardUrl} prefetch={false} className="px-8 pt-6 pb-8">
            <div className="absolute top-0 inset-x-0 h-[260px] sm:h-[310px]" />
            <div className="space-y-[10px]">
              <h3
                className="text-slate-700 text-lg font-semibold tracking-tight"
                title={name}
              >
                {name}
              </h3>
              <ul>
                {!!occupancy?.numGuests && (
                  <li>
                    {`${occupancy?.numGuests} ${
                      occupancy?.numGuests === 1 ? t('guest') : t('guests')
                    }`}
                  </li>
                )}
                {!!occupancy?.numBedrooms && (
                  <li>
                    {`${occupancy?.numBedrooms} ${
                      occupancy?.numBedrooms === 1
                        ? t('bedroom')
                        : t('bedrooms')
                    }`}
                  </li>
                )}
                {!!occupancy?.numBeds && (
                  <li>
                    {`${occupancy?.numBeds} ${
                      occupancy?.numBeds === 1 ? t('bed') : t('beds')
                    }`}
                  </li>
                )}
                {occupancy?.petsAllowed
                  ? <li>{t('pets-allowed')}</li>
                  : null}
              </ul>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};
